module.exports = __webpack_public_path__ + "static/img/glaeser.0cb7766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/glaeser.jpg
// module id = 294
// module chunks = 0